import { CLIENT_ACTIVE } from './constants';
import { ajaxPromise, checkChosenChanged, confirmDialog, displayNotification, getDateFilter, getDtRowData, highlight, initDateFilter, logerror, setDateFilter, setTimeoutPromise, zxcvbnProgressBar } from './utils';

if ($('#superadmin_container').length) {
	const initBackupsHistory = async () => {
		const $client = $('#superadmin_backups_client');
		try {
			const res = await ajaxPromise('/superadmin/backup_clients');
			$client.empty();
			(res.data || []).forEach((client) => {
				$client.append($('<option>', { value: client.cli_id, text: client.cli_name }));
			});
			$client.chosen({ width: '100%', search_contains: true });
		} catch (error) {
			displayNotification('Backups', 'There was an error loading clients.', 'danger');
			logerror('superadmin backup clients', error);
			return;
		}

		const backupsHistoryDt = $('#superadmin_backups_history_table').DataTable({
			ajax: {
				url: '/superadmin/datatable/backups_history',
				data: (data: any) => {
					data.cli_id = $client.val();
					return data;
				},
			},
			columns: [
				{
					title: 'Date',
					data: 'buh_readydate_nice',
					searchable: false,
				},
				{
					title: 'Database',
					data: 'db_size_pretty',
					searchable: false,
				},
				{
					title: 'Files',
					data: 'docs_size_pretty',
					render: (data, type, row) => {
						if (type !== 'display' || !row.segments?.length) return data;
						return `<a href="#" class="backup_files_breakdown">${data}</a>`;
					},
					searchable: false,
				},
				{
					title: 'Delete Date',
					data: 'buh_deletedate_nice',
					searchable: false,
				},
				{
					title: 'Actions',
					data: 'buttons',
					className: 'text-right',
					orderable: false,
					searchable: false,
				},
			],
			order: [[0, 'desc']],
			language: {
				emptyTable: 'No backups for this client',
			},
		});

		$client.on('change', () => backupsHistoryDt.ajax.reload());

		$('#superadmin_backups_history_table').on('click', '.backup_download', async (event) => {
			const $btn = $(event.currentTarget);
			const backup = getDtRowData(backupsHistoryDt, event.currentTarget);
			$btn.prop('disabled', true);
			try {
				const res = await fetch(`/superadmin/backup_download/${backup.buh_id}`);
				const type = res.headers.get('content-type') || '';
				if (!res.ok || !type.includes('zip')) {
					let message = 'This backup could not be downloaded.';
					try {
						const json = await res.json();
						if (json.message) message = json.message;
					} catch {}
					displayNotification('Backup Download', message, 'danger');
					return;
				}

				const blob = await res.blob();
				const disposition = res.headers.get('content-disposition') || '';
				const match = disposition.match(/filename="([^"]+)"/);
				const filename = match ? match[1] : 'backup.zip';
				const url = URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.download = filename;
				document.body.appendChild(link);
				link.click();
				link.remove();
				URL.revokeObjectURL(url);
			} catch (error) {
				displayNotification('Backup Download', 'This backup could not be downloaded.', 'danger');
				logerror('superadmin backup download', error);
			} finally {
				$btn.prop('disabled', false);
			}
		});

		$('#superadmin_backups_history_table').on('click', '.backup_files_breakdown', (event) => {
			event.preventDefault();
			const backup = getDtRowData(backupsHistoryDt, event.target);
			const rows = (backup.segments || []).map((segment) => (
				`<tr><td>${segment.name}</td><td>${segment.description || ''}</td><td>${segment.count_pretty}</td><td>${segment.size_pretty}</td></tr>`
			)).join('');
			$('#superadmin_backup_files_label').text(`Files · ${backup.buh_readydate_nice}`);
			$('#superadmin_backup_files_body').html(rows || '<tr><td colspan="4">No folder breakdown for this snapshot.</td></tr>');
			$('#superadmin_backup_files_modal').modal('show');
		});
	};

	$('#superadmin_backups_tab').one('show.bs.tab', () => initBackupsHistory());

	const initClients = () => {
		const clientsDtOptions: DataTables.Settings = {
			ajax: {
				url: '/superadmin/datatable/clients',
			},
			buttons: [
				{
					text: '<i class="fa fa-plus" style="margin-right: 1rem;"></i>Add Client',
					className: 'add ml-2 btn btn-sm btn-success',
					action: () => editClient(),
				},
				{
					text: '<i class="fa fa-refresh me-2"></i> Refresh',
					className: 'add ml-2 btn btn-sm btn-primary',
					action: () => clientsDt.ajax.reload(),
				},
			],
			columns: [
				{
					title: 'Name',
					data: 'cli_name',
				},
				{
					title: 'Status',
					data: 'cli_status_pretty',
				},
				{
					title: 'Backup',
					data: 'backup_pretty',
					type: 'num',
					render: (data, type, row) => (type === 'sort' || type === 'type') ? row.backup_sort : data,
				},
				{
					title: 'Documents',
					data: 'docs_pretty',
					type: 'num',
					render: (data, type, row) => (type === 'sort' || type === 'type') ? row.docs_size : data,
				},
				{
					title: 'Database',
					data: 'db_size_pretty',
					type: 'num',
					render: (data, type, row) => (type === 'sort' || type === 'type') ? row.db_size : data,
				},
				{
					title: 'Actions',
					data: 'buttons',
					className: 'text-right',
					orderable: false,
					searchable: false,
				},
			],
			language: {
				infoEmpty: 'Refresh to view data',
			},
			serverSide: false,
		};

		const clientFilters: { status: string; backup: string; backupDate: ReturnType<typeof getDateFilter> } = { status: '', backup: '', backupDate: null };

		const newYorkToday = () => {
			const formatted = new Intl.DateTimeFormat('en-CA', {
				timeZone: 'America/New_York',
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
			}).format(new Date());
			const [year, month, day] = formatted.split('-').map(Number);
			return new Date(year, month - 1, day);
		};

		const isoDay = (date: Date) => {
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			return `${date.getFullYear()}-${month}-${day}`;
		};

		const matchesBackupDate = (lastBackup: string, filter: ReturnType<typeof getDateFilter>) => {
			if (!filter || !filter.operator) return true;
			const day = lastBackup.slice(0, 10);
			if (!day) return false;

			const today = newYorkToday();
			switch (filter.operator) {
				case 'equal':
					return filter.first ? day === filter.first : true;
				case 'less':
					return filter.first ? day < filter.first : true;
				case 'greater':
					return filter.first ? day > filter.first : true;
				case 'between': {
					if (filter.first && filter.second) {
						const min = filter.first < filter.second ? filter.first : filter.second;
						const max = filter.first < filter.second ? filter.second : filter.first;
						return day >= min && day <= max;
					}
					if (filter.first) return day >= filter.first;
					if (filter.second) return day <= filter.second;
					return true;
				}
				case 'tweek':
				case 'lweek': {
					const start = new Date(today);
					start.setDate(today.getDate() - today.getDay());
					if (filter.operator === 'lweek') start.setDate(start.getDate() - 7);
					const end = new Date(start);
					end.setDate(start.getDate() + 6);
					return day >= isoDay(start) && day <= isoDay(end);
				}
				case 'tmonth':
					return day.slice(0, 7) === isoDay(today).slice(0, 7);
				case 'lmonth': {
					const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
					return day.slice(0, 7) === isoDay(lastMonth).slice(0, 7);
				}
				case 'tyear':
					return day.slice(0, 4) === String(today.getFullYear());
				case 'lyear':
					return day.slice(0, 4) === String(today.getFullYear() - 1);
				default:
					return true;
			}
		};

		$.fn.dataTable.ext.search.push((settings, _data, _index, row) => {
			if (settings.nTable.id !== 'superadmin_clients_table') return true;
			if (clientFilters.status !== '' && String(row.cli_status) !== clientFilters.status) return false;
			if (clientFilters.backup === 'none' || clientFilters.backup === 'never') {
				if (row.backup_state !== clientFilters.backup) return false;
			}
			else if (clientFilters.backup === 'configured') {
				if (row.backup_state !== 'stale' && row.backup_state !== 'current') return false;
				if (!matchesBackupDate(String(row.last_backup || ''), clientFilters.backupDate)) return false;
			}
			return true;
		});

		const clientsDt = $('#superadmin_clients_table').DataTable(clientsDtOptions);

		initDateFilter('#superadmin_clients_filter_backup_date');
		$('#superadmin_clients_filter_backup_date').chosen({ width: '100%' });

		const applyClientFilters = () => {
			clientFilters.status = $('#superadmin_clients_filter_status').val().toString();
			clientFilters.backup = $('#superadmin_clients_filter_backup').val().toString();
			const showDate = clientFilters.backup === 'configured';
			$('#superadmin_clients_filter_backup_date_group').toggle(showDate);
			if (!showDate) {
				setDateFilter('#superadmin_clients_filter_backup_date', null);
				$('#superadmin_clients_filter_backup_date').trigger('chosen:updated');
			}
			checkChosenChanged($('#superadmin_clients_filter_backup_date'));
			clientFilters.backupDate = showDate ? getDateFilter('#superadmin_clients_filter_backup_date') : null;
			clientsDt.draw();
		};

		$('#superadmin_clients_filter_status, #superadmin_clients_filter_backup').on('change', () => applyClientFilters());
		$('#superadmin_clients_filter_backup_date_group').on('change', () => applyClientFilters());

		$('#superadmin_clients_table').on('click', '.edit', ({ target }) => {
			const client = getDtRowData(clientsDt, target);
			editClient(client);
		});

		const parseClientDbInfo = (raw: string) => {
			try {
				const parsed = JSON.parse(raw || '{}');
				if (parsed && typeof parsed === 'object') {
					return {
						host: parsed.host || '',
						name: parsed.name || '',
						user: parsed.user || '',
						pass: parsed.pass || '',
					};
				}
			} catch {}
			return { host: '', name: '', user: '', pass: '' };
		};

		const serializeClientDbInfo = () => JSON.stringify({
			host: $('#superadmin_client_db_host').val().toString().trim(),
			name: $('#superadmin_client_db_name').val().toString().trim(),
			user: $('#superadmin_client_db_user').val().toString().trim(),
			pass: $('#superadmin_client_db_pass').val().toString().trim(),
		});

		const backupTypeFromMeta = (meta: string) => {
			if (!meta) return '';
			try {
				const parsed = JSON.parse(meta);
				if (parsed?.protocol === 's3' && parsed.target === 'vultr') return 's3';
				if (parsed?.protocol === 'file_system') return 'file_system';
			} catch {}
			return 'other';
		};

		const backupMetaFromType = (type: string, otherMeta = '') => {
			if (type === 's3') return JSON.stringify({ protocol: 's3', target: 'vultr' });
			if (type === 'file_system') return JSON.stringify({ protocol: 'file_system' });
			if (type === 'other') return otherMeta;
			return '';
		};

		const arrayBufferToPem = (buffer: ArrayBuffer, label: string) => {
			const bytes = new Uint8Array(buffer);
			let binary = '';
			bytes.forEach((byte) => {
				binary += String.fromCharCode(byte);
			});
			const lines = btoa(binary).match(/.{1,64}/g) || [];
			return `-----BEGIN ${label}-----\n${lines.join('\n')}\n-----END ${label}-----\n`;
		};

		const downloadPem = (filename: string, content: string) => {
			const url = URL.createObjectURL(new Blob([content], { type: 'application/x-pem-file' }));
			const link = document.createElement('a');
			link.href = url;
			link.download = filename;
			document.body.appendChild(link);
			link.click();
			link.remove();
			URL.revokeObjectURL(url);
		};

		const generateBackupKeys = async () => {
			const existing = $('#superadmin_backup_key').val().toString().trim();
			const confirmed = await confirmDialog({
				dialogTitle: 'Generate Backup Keys',
				bodyText: existing
					? 'This will replace the public key and download a new private key. Store the private key offline — it cannot be recovered from 3PT.'
					: 'This will fill the public key and download a private key. Store the private key offline — it cannot be recovered from 3PT.',
				confirmText: 'Generate',
				confirmStyle: 'primary',
			});
			if (!confirmed) return;

			const $btn = $('#superadmin_backup_generate');
			$btn.prop('disabled', true);

			try {
				const keyPair = await crypto.subtle.generateKey(
					{
						name: 'RSA-OAEP',
						modulusLength: 2048,
						publicExponent: new Uint8Array([1, 0, 1]),
						hash: 'SHA-256',
					},
					true,
					['encrypt', 'decrypt']
				);
				const [publicKey, privateKey] = await Promise.all([
					crypto.subtle.exportKey('spki', keyPair.publicKey),
					crypto.subtle.exportKey('pkcs8', keyPair.privateKey),
				]);
				$('#superadmin_backup_key').val(arrayBufferToPem(publicKey, 'PUBLIC KEY'));
				syncBackupCopyButton();

				const name = $('#superadmin_client_name').val().toString().trim().replace(/[^\w-]+/g, '_') || 'client';
				downloadPem(`${name}-private.key`, arrayBufferToPem(privateKey, 'PRIVATE KEY'));
				displayNotification('Backup Keys', 'Private key downloaded. Store it offline — it cannot be recovered.', 'success');
			} catch (error) {
				displayNotification('Backup Keys', 'There was an error generating backup keys.', 'danger');
				logerror('backup key generate', error);
			}

			$btn.prop('disabled', false);
		};

		$('#superadmin_backup_generate').on('click', () => generateBackupKeys());

		const copyBackupKey = async () => {
			const key = $('#superadmin_backup_key').val().toString();
			if (key.trim() === '') {
				displayNotification('Public Key', 'There is no public key to copy.', 'danger');
				return;
			}

			try {
				await navigator.clipboard.writeText(key);
				displayNotification('Public Key', 'Public key copied to clipboard.', 'success');
			} catch (error) {
				const textarea = $('#superadmin_backup_key').get(0) as HTMLTextAreaElement;
				textarea.focus();
				textarea.select();
				if (document.execCommand('copy')) {
					displayNotification('Public Key', 'Public key copied to clipboard.', 'success');
				} else {
					displayNotification('Public Key', 'Failed to copy the public key.', 'danger');
					logerror('backup key copy', error);
				}
			}
		};

		const syncBackupCopyButton = () => {
			$('#superadmin_backup_copy').toggle($('#superadmin_backup_key').val().toString().trim() !== '');
		};

		$('#superadmin_backup_copy').on('click', () => copyBackupKey());
		$('#superadmin_backup_key').on('focus', ({ target }) => {
			if ($(target).prop('readonly')) {
				(target as HTMLTextAreaElement).select();
			}
		}).on('input', () => syncBackupCopyButton());

		const resetClientForm = () => {
			$('#superadmin_client_name').val('');
			$('#superadmin_client_status').val(CLIENT_ACTIVE);
			$('#superadmin_client_subdomain').val('');
			$('#superadmin_client_domain').val('');
			$('#superadmin_client_db_host').val('');
			$('#superadmin_client_db_name').val('');
			$('#superadmin_client_db_user').val('');
			$('#superadmin_client_db_pass').val('');
			$('#superadmin_backup_type').val('').removeData('other-meta');
			$('#superadmin_backup_key').val('').prop('readonly', false);
			$('#superadmin_backup_copy').hide();
			$('#superadmin_backup_generate').hide();
			$('#superadmin_backup_delete').off('click').hide();
			$('#superadmin_client_form').off('submit');
		};

		const setBackupKeyLocked = (locked: boolean) => {
			$('#superadmin_backup_key').prop('readonly', locked);
			$('#superadmin_backup_generate').toggle(!locked);
		};

		const editClient = (client: any = null) => {
			resetClientForm();
			const hasBackup = !!(client && client.bkup_id);
			setBackupKeyLocked(hasBackup);
			setTimeout(() => {
				highlight($('#superadmin_client_form'));
				$(window).scrollTop($('#superadmin_client_form').offset()!.top - 400);
			}, 400);

			if (client) {
				const dbinfo = parseClientDbInfo(client.cli_dbinfo);
				$('#superadmin_client_name').val(client.cli_name);
				$('#superadmin_client_status').val(client.cli_status);
				$('#superadmin_client_subdomain').val(client.cli_subdomain);
				$('#superadmin_client_domain').val(client.cli_domain);
				$('#superadmin_client_db_host').val(dbinfo.host);
				$('#superadmin_client_db_name').val(dbinfo.name);
				$('#superadmin_client_db_user').val(dbinfo.user);
				$('#superadmin_client_db_pass').val(dbinfo.pass);
				$('#superadmin_backup_type').val(backupTypeFromMeta(client.bkup_meta || '')).data('other-meta', client.bkup_meta || '');
				$('#superadmin_backup_key').val(client.bkup_key || '');
				syncBackupCopyButton();

				if (client.bkup_id) {
					$('#superadmin_backup_delete').show().on('click', async () => {
						const confirmed = await confirmDialog({
							dialogTitle: 'Backup Delete',
							bodyText: 'Are you sure you would like to delete this Backup?',
							confirmText: 'Delete',
							confirmStyle: 'danger',
						});
						if (!confirmed) return;

						try {
							const res = await ajaxPromise('/superadmin/submit/backup_delete', { data: JSON.stringify({ bkup_id: +client.bkup_id }) });
							if (res.rc !== 'OK') throw res;

							displayNotification('Backup Delete', 'Backup deleted successfully.', 'success');
							client.bkup_id = null;
							$('#superadmin_backup_type').val('').removeData('other-meta');
							$('#superadmin_backup_key').val('');
							setBackupKeyLocked(false);
							syncBackupCopyButton();
							$('#superadmin_backup_delete').hide();
							clientsDt.ajax.reload();
						} catch (error) {
							displayNotification('Backup Delete', 'There was an error deleting this backup.', 'danger');
							logerror('backup delete', error);
						}
					});
				}
			}

			$('#superadmin_client_form').on('submit', async (event) => {
				event.preventDefault();

				$('#superadmin_client_submit').prop('disabled', true);

				try {
					const backupType = $('#superadmin_backup_type').val().toString();
					const meta = backupMetaFromType(backupType, $('#superadmin_backup_type').data('other-meta') || '');
					const key = $('#superadmin_backup_key').val().toString().trim();
					if (backupType !== '' && key === '') {
						displayNotification('Client Save', 'A public key is required to enable daily backup.', 'danger');
						$('#superadmin_client_submit').prop('disabled', false);
						return;
					}

					const postData = {
						cli_id: client ? +client.cli_id : null,
						cli_name: $('#superadmin_client_name').val().toString().trim(),
						cli_status: +$('#superadmin_client_status').val().toString().trim(),
						cli_subdomain: $('#superadmin_client_subdomain').val().toString().trim(),
						cli_domain: $('#superadmin_client_domain').val().toString().trim(),
						cli_dbinfo: serializeClientDbInfo(),
					};
					const res = await ajaxPromise('/superadmin/submit/client_save', { data: JSON.stringify(postData) });
					if (res.rc !== 'OK') throw Error(res);

					const cliId = client ? +client.cli_id : +res.cli_id;
					if (meta !== '' && key !== '') {
						const backupRes = await ajaxPromise('/superadmin/submit/backup_save', {
							data: JSON.stringify({
								bkup_id: client && client.bkup_id ? +client.bkup_id : null,
								client: cliId,
								meta,
								key,
							}),
						});
						if (backupRes.rc !== 'OK') throw Error(backupRes);
					}

					displayNotification('Client Save', 'Client saved successfully.', 'success');
					clientsDt.ajax.reload();
					$('#superadmin_client_form').collapse('hide');
				} catch (error) {
					switch (error.message) {
						default:
							displayNotification('Client Save', 'There was an error saving this client.', 'danger');
							break;
					}
					logerror('client submit', error);
				}

				$('#superadmin_client_submit').prop('disabled', false);
			});

			$('#superadmin_client_form').collapse('show');
		};

		$('#superadmin_client_form').on('hidden.bs.collapse', () => resetClientForm());

		$('#superadmin_client_cancel').off('click').on('click', () => $('#superadmin_client_form').collapse('hide'));
	};

	initClients();

	const initUsers = () => {
		const usersDtOptions: DataTables.Settings = {
			ajax: {
				url: '/superadmin/datatable/users',
			},
			buttons: [
				{
					text: '<i class="fa fa-plus" style="margin-right: 1rem;"></i>Add User',
					className: 'add ml-2 btn btn-sm btn-success',
					action: () => editUser(),
				},
			],
			columns: [
				{
					title: 'Name',
					data: 'admin_name',
				},
				{
					title: 'Email',
					data: 'admin_email',
				},
				{
					title: 'Actions',
					data: 'buttons',
					className: 'text-right',
					orderable: false,
					searchable: false,
				},
			],
		};

		const usersDt = $('#superadmin_users_table').DataTable(usersDtOptions);

		$('#superadmin_users_table').on('click', '.edit', ({ target }) => {
			const user = getDtRowData(usersDt, target);
			editUser(user);
		});

		const resetUserForm = () => {
			$('#superadmin_user_first').val('');
			$('#superadmin_user_last').val('');
			$('#superadmin_user_email').val('');
			$('#superadmin_user_form').off('submit');

			$('#superadmin_user_pass_cont').hide();
			$('#superadmin_user_old_pass').val('');
			$('#superadmin_user_pass').val('').trigger('keyup');
			$('#superadmin_user_pass_confirm').val('');
		};

		const editUser = (user = null) => {
			resetUserForm();
			setTimeout(() => {
				highlight($('#superadmin_user_form'));
				$(window).scrollTop($('#superadmin_user_form').offset()!.top - 400);
			}, 400);

			if (user) {
				$('#superadmin_user_first').val(user.admin_first);
				$('#superadmin_user_last').val(user.admin_last);
				$('#superadmin_user_email').val(user.admin_email);

				if (user.is_self) {
					$('#superadmin_user_pass_cont').show();

					zxcvbnProgressBar($('#superadmin_user_pass_meter'), {
						passwordInput: '#superadmin_user_pass',
						scoreInput: '#superadmin_user_pass_score',
						warningTarget: '#superadmin_user_pass_warning',
						suggestionsTarget: '#superadmin_user_pass_suggestions',
					});

					$('#superadmin_user_pass, #superadmin_user_pass_confirm').on('blur', async ({ target }) => {
						await setTimeoutPromise(10);
						if ((target.id == 'superadmin_user_pass' && !$('#superadmin_user_pass_confirm').is(':focus')) || target.id == 'superadmin_user_pass_confirm') {
							if ($('#superadmin_user_pass').val() != '' && +$('#superadmin_user_pass_score').val() < 2) {
								$('#superadmin_user_pass').closest('.form-group').find('[class^=col-]').addClass('has-error');
								$('#superadmin_user_pass_help').html('The password is not strong enough.');
							} else if ($('#superadmin_user_pass').val() != $('#superadmin_user_pass_confirm').val()) {
								$('#superadmin_user_pass').closest('.form-group').find('[class^=col-]').addClass('has-error');
								$('#superadmin_user_pass_help').html("The passwords you've entered do not match.");
							} else {
								$('#superadmin_user_pass').closest('.form-group').find('[class^=col-]').removeClass('has-error');
								$('#superadmin_user_pass_help').html('<strong>OPTIONAL:</strong> If you would like to change your password, fill out all the password fields.');
							}
						}
					});
				}
			}

			$('#superadmin_user_form').on('submit', async (event) => {
				event.preventDefault();

				$('#superadmin_user_submit').prop('disabled', true);

				try {
					const postData = {
						admin_id: user ? +user.admin_id : null,
						first: $('#superadmin_user_first').val().toString().trim(),
						last: $('#superadmin_user_last').val().toString().trim(),
						email: $('#superadmin_user_email').val().toString().trim(),
						old_pass: $('#superadmin_user_old_pass').val().toString().trim(),
						pass: $('#superadmin_user_pass').val().toString().trim(),
						pass_confirm: $('#superadmin_user_pass_confirm').val().toString().trim(),
					};
					const res = await ajaxPromise('/superadmin/submit/user_save', { data: JSON.stringify(postData) });
					if (res.rc !== 'OK') throw Error(res);

					displayNotification('User Save', 'User saved successfully.', 'success');
					usersDt.ajax.reload();
					$('#superadmin_user_form').collapse('hide');
				} catch (error) {
					switch (error.message) {
						default:
							displayNotification('User Save', 'There was an error saving this user.', 'danger');
							break;
					}
					logerror('superadmin user submit', error);
				}

				$('#superadmin_user_submit').prop('disabled', false);
			});

			$('#superadmin_user_form').collapse('show');
		};

		$('#superadmin_user_form').on('hidden.bs.collapse', () => resetUserForm());

		$('#superadmin_user_cancel').off('click').on('click', () => $('#superadmin_user_form').collapse('hide'));
	};

	$('#superadmin_users_tab').one('show.bs.tab', () => initUsers());

	const validTabs = ['#superadmin_clients', '#superadmin_backups', '#superadmin_users'];
	$('#superadmin_container a[data-toggle="tab"]').on('shown.bs.tab', (event) => {
		const href = $(event.target).attr('href');
		if (href && validTabs.includes(href) && window.history.replaceState) {
			window.history.replaceState(null, '', href);
		}
	});

	const hash = window.location.hash;
	if (hash && validTabs.includes(hash)) {
		$(`#superadmin_container a[href="${hash}"]`).tab('show');
	}
}

if ($('#superadmin_login_form').length) {
	$('#superadmin_login_form').on('submit', async (event) => {
		event.preventDefault();

		$('#superadmin_login_submit').prop('disabled', true);

		try {
			const postData = {
				email: $('#superadmin_login_form_email').val().toString().trim(),
				password: $('#superadmin_login_form_password').val().toString().trim(),
			};
			const res = await ajaxPromise('/login/superadmin/login', { data: JSON.stringify(postData) });
			if (res.rc !== 'OK') throw res;

			window.location.reload();
		} catch (error) {
			switch (error.rc) {
				case 'BAD_LOGIN':
					displayNotification('Login', 'Login failed.', 'danger');
					break;
				default:
					displayNotification('Login', 'There was an error logging in.', 'danger');
					logerror('superadmin login submit', error);
			}
		}

		$('#superadmin_login_submit').prop('disabled', false);
	});

	$('#superadmin_login_form_forgot').off('click').on('click', (event) => {
		event.preventDefault();
		$('#superadmin_login_forgot_email').val($('#superadmin_login_form_email').val());
		$('#superadmin_login_forgot_modal').modal('show');

		$('#superadmin_login_forgot_send').off('click').on('click', async () => {
			if ($('#superadmin_login_forgot_email').val().toString() == '') {
				displayNotification('Forgot Password', 'Please enter the email address your account was registered with.', 'danger');
				return;
			}

			$('#superadmin_login_forgot_send').prop('disabled', true);

			try {
				const postData = {
					email: $('#superadmin_login_forgot_email').val().toString().trim(),
				};
				const res = await ajaxPromise('/login/superadmin/forgot_password', { data: JSON.stringify(postData) });
				if (res.rc !== 'OK') throw res;

				displayNotification('Forgot Password', 'Temporary password has been sent.', 'info');
				$('#superadmin_login_forgot_modal').modal('hide');
			} catch (error) {
				displayNotification('Forgot Password', 'An error occurred while sending this request.', 'danger');
				logerror('forgotpassword', error);
			}

			$('#superadmin_login_forgot_send').prop('disabled', false);
		});
	});
}

if ($('#superadmin_mfa_form').length) {
	$('#superadmin_mfa_form').off('submit').on('submit', async (event) => {
		event.preventDefault();

		$('#superadmin_mfa_form_spinner').show();
		$('#superadmin_mfa_form_submit').prop('disabled', true);

		try {
			const postData = {
				code: $('#superadmin_mfa_form_code').val().toString(),
			};

			const res = await ajaxPromise('/login/superadmin/mfa', { data: JSON.stringify(postData) });
			if (res.rc !== 'OK') throw res.rc;

			window.location.href = '/superadmin';
		} catch (error) {
			switch (error) {
				case 'NO_MFA_LOGIN':
					window.location.href = '';
					break;
				case 'INVALID_CODE':
					displayNotification('Login', 'Incorrect code.', 'danger');
					break;
				default:
					displayNotification('Login', 'An error occured while logging in.', 'danger');
					logerror('superadmin mfa_form_submit', error);
			}
		}

		$('#superadmin_mfa_form_spinner').hide();
		$('#superadmin_mfa_form_submit').prop('disabled', false);
	});

	$('#superadmin_mfa_form_resend').off('click').on('click', async (event) => {
		event.preventDefault();

		$('#superadmin_mfa_form_spinner').show();
		$('#superadmin_mfa_form_resend').prop('disabled', true);

		try {
			const res = await ajaxPromise('/login/superadmin/send_mfa');
			if (res.rc !== 'OK') throw res.rc;

			displayNotification('Login', 'A new code has been sent.', 'success');
		} catch (error) {
			switch (error) {
				case 'NO_MFA_LOGIN':
					window.location.href = '';
					break;
				default:
					displayNotification('Login', 'An error occured while sending the code.', 'danger');
					logerror('superadmin mfa_form_resend', error);
			}
		}

		$('#superadmin_mfa_form_spinner').hide();
		$('#superadmin_mfa_form_resend').prop('disabled', false);
	});
};